module.exports = __webpack_public_path__ + "static/img/icon_radio_plus.09125560.svg";